/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { User } from '@touchplan/common';

export const parseName = (userData: User): string | undefined => {
	if (!userData) {
		return undefined;
	}

	if (!userData.firstName && !userData.lastName) {
		return userData.email;
	}

	return (userData.firstName ? userData.firstName : '') + ' ' + (userData.lastName ? userData.lastName : '');
};
